export const STATUS_STEPS = [
  { key: 'New Lead', label: 'Application Received' },
  { key: 'Documents Pending', label: 'Documents Pending' },
  { key: 'Documents Completed', label: 'Documents Submitted' },
  { key: 'Assigned to Banker', label: 'Assigned to Bank' },
  { key: 'Under Review', label: 'Under Review' },
  { key: 'Query Raised', label: 'Query Raised' },
  { key: 'Approved', label: 'Loan Approved' },
  { key: 'Sanctioned', label: 'Sanctioned' },
  { key: 'Disbursed', label: 'Amount Disbursed' },
  { key: 'Closed', label: 'Completed' },
];

export const SPECIAL_STATUSES = {
  Rejected: {
    color: 'red',
    title: 'Application Rejected',
    msg: 'Your loan application was rejected. Please contact your advisor for more details.',
  },
  Cancelled: {
    color: 'amber',
    title: 'Application Cancelled',
    msg: 'Your application has been cancelled. Please contact us if this is an error.',
  },
  Hold: {
    color: 'amber',
    title: 'Application On Hold',
    msg: 'Your application is currently on hold. Our team will reach out to you shortly.',
  },
};

export const formatINR = (v) =>
  new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
    maximumFractionDigits: 0,
  }).format(v);
